import { getVideo, putLikesApi, putUnLikesApi } from "./videoAPI";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    video: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchVideo = createAsyncThunk("video/fetchVideo", async (id) => {
    const video = await getVideo(id);
    return video;
});

export const putLike = createAsyncThunk(
    "video/putLike",
    async ({ id, likes }) => {
        const videoLikes = await putLikesApi({ id, likes });
        return videoLikes;
    }
);

export const putUnLike = createAsyncThunk(
    "video/putUnLike",
    async ({ id, unlikes }) => {
        const videoLikes = await putUnLikesApi({ id, unlikes });
        return videoLikes;
    }
);

const videoSlice = createSlice({
    name: "video",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchVideo.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
            })
            .addCase(putLike.fulfilled, (state, action) => {
                state.video.likes = action.payload.likes;
            })
            .addCase(putUnLike.fulfilled, (state, action) => {
                state.video.unlikes = action.payload.unlikes;
            });
    },
});

export default videoSlice.reducer;
